import mixins from 'synergycms_core/src/less/mixins';

export default {
    resumeFull: {},
    resume: {},
    bookingResume: {},
    hotelInfo: {},
    stars: {},
    hotelTitle: {},
    hotelAddress: {},
    bookingDetailContainer: {},
    bookingDetail: {},
    bookingDetailRow: {},
    bookingDetailColumn: {},
    bookingDetailColumn2: {},
    adultOccup: {},
    childOccup: {},
    roomDetailContainer: {},
    extraDetailContainer: {},
    extraDetail: {},
    extraDetailRow: {},
    extraName: {},
    extraPrice: {},
    actionsContainer: {},
    summary: {},
    actions: {},
    actionsGrid: {},
    actionContainer: {},
    actionIconContainer: {},
    actionIcon: {},
    resumeFullContainer: {
        font: data => '300 13px ' + data.fontFamily1,
        background: '#f1f1f1',
        textAlign: 'left',
        paddingBottom: '20px',
        '&:lang(ar)': {
            textAlign: 'right'
        },
        '& $resumeFull': {
            backgroundColor: '#fff',
            ...mixins.boxShadow('0 3px 4px 0 rgba(0, 0, 0, 0.3)'),
            ...mixins.boxSizing('content-box'),
            border: 0,
            color: 'inherit',
            padding: 0,
            '& $resume': {
                padding: '20px 0 0',
                '& $bookingResume': {
                    '& > div': {
                        paddingLeft: '20px',
                        paddingRight: '20px',
                        position: 'relative',
                        '@media (min-width: 801px), print': {
                            paddingLeft: '0',
                            paddingRight: '0'
                        }
                    },
                    '& > div:last-child': {
                        '& > div': {
                            '&:after': {
                                content: 'none'
                            }
                        }
                    },
                    '& $hotelInfo': {
                        paddingBottom: '13px',
                        '& $stars': {
                            display: 'block',
                            marginBottom: '3px',
                            '@media (min-width: 801px), print': {
                                fontSize: '13px'
                            }
                        },
                        '& $hotelTitle': {
                            fontSize: '16px',
                            fontWeight: '500',
                            '@media (min-width: 801px), print': {
                                fontSize: '24px',
                                fontWeight: 'normal'
                            }
                        },
                        '& $hotelAddress': {
                            color: '#666',
                            lineHeight: '1.38',
                            '@media (min-width: 801px), print': {
                                fontSize: '13px'
                            }
                        },
                        '&:after': {
                            position: 'absolute',
                            borderBottom: '1px solid #d8d8d8',
                            left: '20px',
                            right: '20px',
                            content: "''",
                            bottom: '0',
                            '@media (min-width: 801px), print': {
                                content: 'none'
                            }
                        },
                        '@media (min-width: 801px), print': {
                            paddingBottom: '20px'
                        }
                    },
                    '& $bookingDetailContainer': {
                        '& $bookingDetail': {
                            display: 'table',
                            width: '100%',
                            padding: '10px 0 15px',
                            margin: '0',
                            '@media (min-width: 801px), print': {
                                padding: 0
                            }
                        },
                        '& $bookingDetailRow': {
                            lineHeight: '1.85',
                            display: 'table-row',
                            listStyle: 'none',
                            '& > *:nth-child(even)': {
                                paddingLeft: '10px',
                                textAlign: 'left',
                                '&:lang(ar)': {
                                    textAlign: 'right',
                                    paddingRight: '10px',
                                    paddingLeft: 0
                                },
                            },
                            '& $bookingDetailColumn': {
                                display: 'table-cell',
                                fontSize: '13px',
                                '& > span': {
                                    fontSize: '13px',
                                    fontWeight: '500',
                                    '@media (min-width: 801px), print': {
                                        fontSize: '16px'
                                    }
                                },
                                '@media (min-width: 801px), print': {
                                    fontSize: '16px',
                                    lineHeight: '1.85'
                                }
                            },
                            '& $bookingDetailColumn2': {
                                display: 'table-cell',
                                fontSize: '13px',
                                '& > span': {
                                    '@media (min-width: 801px), print': {
                                        fontSize: '16px'
                                    }
                                },
                                '@media (min-width: 801px), print': {
                                    fontSize: '16px',
                                    lineHeight: '1.85'
                                }
                            },
                            '& $adultOccup': {
                                font: '15px/1px Icons',
                                color: data => data.mainColor,
                                lineHeight: '0',
                                display: 'inline-block',
                                marginRight: '2px',
                                marginTop: '-7px',
                                '&:lang(ar)': {
                                    marginRight: 0,
                                    marginLeft: '7px'
                                },
                            },
                            '& $childOccup': {
                                left: '7px',
                                font: '10px/1px Icons',
                                color: data => data.mainColor,
                                '&:lang(ar)': {
                                    right: '7px',
                                    left: 'auto'
                                },
                            }
                        },
                        // '&:after': {
                        //     position: 'absolute',
                        //     borderBottom: '1px solid #d8d8d8',
                        //     left: '20px',
                        //     right: '20px',
                        //     content: "''",
                        //     bottom: '0',
                        //     '@media (min-width: 801px), print': {
                        //         left: 0,
                        //         right: 0
                        //     }
                        // },
                        '@media (min-width: 801px), print': {
                            paddingBottom: '23px'
                        },
                        '&:lang(ar)': {
                            direction: 'rtl',
                        },
                    },
                    '& $roomDetailContainer': {
                        '& > div': {
                            '&:not(:last-of-type)': {
                                borderBottom: '1px solid #d8d8d8'
                            },
                            '&:after': {
                                position: 'absolute',
                                borderBottom: '1px solid #d8d8d8',
                                left: '20px',
                                right: '20px',
                                content: "''",
                                bottom: '0'
                            }
                        },
                        '& $extraDetailContainer': {
                            '& $extraDetail': {
                                border: '0',
                                color: 'inherit',
                                margin: '0',
                                padding: '10px 0 15px',
                                display: 'table',
                                width: '100%',
                                '& $extraDetailRow': {
                                    listStyle: 'none',
                                    display: 'table-row',
                                    '& $extraName': {
                                        display: 'table-cell',
                                        width: '50%',
                                        '& > span': {
                                            fontSize: '13px'
                                        },
                                        '& > div': {
                                            '& > span': {
                                                fontSize: '13px',
                                                '@media (min-width: 801px), print': {
                                                    fontSize: '16px'
                                                }
                                            }
                                        },
                                        '&:lang(ar)': {
                                            order: '2',
                                        }
                                    },
                                    '& $extraPrice': {
                                        display: 'table-cell',
                                        paddingLeft: '10px',
                                        textAlign: 'right',
                                        '&:lang(ar)': {
                                            textAlign: 'right',
                                            paddingLeft: '10px',
                                            paddingRight: '0',
                                            order: '1',
                                        },
                                        '& > span': {
                                            fontSize: '13px',
                                            '@media (min-width: 801px), print': {
                                                fontSize: '16px'
                                            }
                                        },
                                        '& > div': {
                                            '& > span': {
                                                fontSize: '13px'
                                            }
                                        }
                                    },
                                    '&:lang(ar)': {
                                        display: 'flex',
                                        justifyContent: 'space-around',
                                    }
                                },
                                '@media (min-width: 801px), print': {
                                    padding: '0'
                                }
                            },
                            '@media (min-width: 801px), print': {
                                padding: '17px 0 14px',
                                '&:last-of-type': {
                                    paddingTop: '5px'
                                }
                            }
                        }
                    },
                    '@media (min-width: 801px), print': {
                        width: '600px',
                        boxSizing: 'content-box',
                        border: '0',
                        color: 'inherit',
                        margin: '0',
                        padding: '0',
                        ...mixins.boxSizing('content-box')
                    },
                    '&:lang(ar)': {
                        '@media (min-width: 801px)': {
                            float: 'right'
                        }
                    }
                },
                '& $summary': {
                    '@media (min-width: 801px), print': {
                        float: 'right',
                        width: '600px',
                        border: '0',
                        margin: '0',
                        padding: '0'
                    },
                    '& $header': {
                        '&:after': {
                            '@media (min-width: 801px), print': {
                                left: 0,
                                right: 0
                            }
                        }
                    },
                    '&:lang(ar)': {
                        '@media (min-width: 801px)': {
                            float: 'left'
                        }
                    }
                },
                '@media (min-width: 801px), print': {
                    ...mixins.boxSizing('content-box'),
                    padding: '20px 30px 15px',
                    borderBottom: '1px solid #d8d8d8',
                    overflow: 'hidden',
                    boxSizing: 'content-box',
                    color: 'inherit',
                    margin: '0',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }
            },
            '& $actionsContainer': {
                paddingTop: '20px',
                '& $actions': {
                    borderTop: '1px solid #d8d8d8',
                    '& $actionsGrid': {
                        padding: '17px 10px 21px',
                        display: 'table',
                        margin: '0 auto',
                        border: '0',
                        color: 'inherit',
                        ...mixins.boxSizing('content-box'),
                        '& $actionContainer': {
                            ...mixins.boxSizing('content-box'),
                            borderRight: '1px solid #d8d8d8',
                            display: 'table-cell',
                            verticalAlign: 'middle',
                            listStyle: 'none',
                            color: 'inherit',
                            margin: '0',
                            padding: '0',
                            '&:lang(ar)': {
                                borderRight: 'none',
                                borderLeft: '1px solid #d8d8d8'
                            },
                            '&:last-child': {
                                border: '0'
                            },
                            '& $actionIconContainer': {
                                width: '63px',
                                height: '100%',
                                color: data => data.mainColor,
                                font: "25px 'Icons'",
                                cursor: 'pointer',
                                overflow: 'visible',
                                boxSizing: 'border-box',
                                fontSize: 'inherit',
                                outline: '0',
                                textAlign: 'center',
                                background: 'none',
                                '& $actionIcon': {
                                    color: data => data.mainColor,
                                    font: "25px 'Icons'"
                                }
                            }
                        },
                        '@media (min-width: 801px), print': {
                            padding: '28px'
                        }
                    },
                    '@media (min-width: 801px), print': {
                        border: 'none',
                        float: 'left'
                    },
                    '&:lang(ar)': {
                        '@media (min-width: 801px)': {
                            float: 'right'
                        }
                    }
                },
                '@media (min-width: 801px), print': {
                    padding: 0,
                    overflow: 'hidden'
                }
            },
            '@media (min-width: 801px), print': {
                maxWidth: '1000px',
                margin: '0 auto'
            }
        },
        '@media (min-width: 801px), print': {
            ...mixins.boxSizing('content-box'),
            padding: '0 20px 20px',
            boxSizing: 'content-box',
            border: '0',
            color: 'inherit',
            margin: '0'
        }
    },
    extraDetailRowFinal:{
        paddingTop:'20px'
    }
}